import FileSaver from 'file-saver'
import { FC, useRef } from 'react'
import ContactUsForm from '@components/contact-us-form/contact-us-form'

export interface FormBeforeDownloadProps {
  show: boolean
  downloadUrl: string
  downloadFileName: string
  beforeClose: () => void
}

const FormBeforeDownload: FC<FormBeforeDownloadProps> = ({ downloadUrl, downloadFileName, show, beforeClose }) => {
  const contactUsFormBoxRef = useRef<HTMLDivElement>(null)

  function closeDialog() {
    contactUsFormBoxRef.current?.scrollTo({
      top: 0,
    })

    beforeClose()
  }

  function onSubmitted(result: boolean) {
    console.log('onSubmitted: ', result)

    if (result) {
      /* successful, then download */
      console.log('onSubmitted downloadUrl: ', downloadUrl, ' ;downloadFileName: ', downloadFileName)
      FileSaver.saveAs(downloadUrl, downloadFileName)

      closeDialog()
    }

    /* failed, then do nothing */
  }

  return (
    <div
      className={[
        'form-before-download fixed top-0 left-0 right-0 w-screen h-screen bg-black/50 z-max',
        show ? '' : 'hidden',
      ].join(' ')}
      onClick={() => closeDialog()}
    >
      <div
        ref={contactUsFormBoxRef}
        className={[
          'px-6',
          'animate-ease-show-from-bottom laptop:animate-ease-show-from-right',
          'absolute top-0 right-0 w-249 max-w-full h-full  laptop:px-125px pt-12 bg-white overflow-auto pb-30',
        ].join(' ')}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between">
          <h2 className="text-2xl laptop:text-4xl font-semibold">Download File</h2>
          <img
            className="block w-6 h-6 laptop:w-10 laptop:h-10 cursor-pointer"
            src="/icons/icon_close.svg"
            alt="close"
            onClick={() => closeDialog()}
          />
        </div>

        <ContactUsForm
          hideTitle={true}
          hideDesc={true}
          cooperationType="5"
          contentAlign="LEFT"
          onSubmitted={(result) => onSubmitted(result)}
        />
      </div>
    </div>
  )
}

export default FormBeforeDownload
